/* eslint-disable react/prop-types */
import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Box,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  makeStyles,
  Typography,
} from '@material-ui/core'
import Icon from '@mdi/react'
import {
  mdiMagnifyExpand,
  mdiMenuLeft,
  mdiMenuRight,
  mdiMicrosoftExcel,
} from '@mdi/js'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import EventIcon from '@material-ui/icons/Event'
import { format, parseISO } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { useConfirm } from 'material-ui-confirm'
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'

import filterStylesComponents from '../../../../assets/filterComponentsStyles'
import { renderRouteRole, useQueryParams } from '../../../../util/utils'
import colors from '../../../../assets/colors'
import {
  closeAllLaundryOSs,
  exportOSsRelatory,
  fetchAttendancePartner,
} from '../PartnerAttendanceActions'
import BaseFilter from '../../../../components/hooks/BaseFilter'

const useStyles = makeStyles({
  filterBox: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    justifyContent: 'flex-start',
    fontSize: '14px',
    lineHeight: '14px',
    color: colors.gray,
  },
  periodFilter: {
    color: colors.primary,
    display: 'flex',
    minWidth: '210px',
    padding: '4px',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: `1px solid ${colors.graylight}`,
    borderRadius: '5px',
    fontSize: '14px',
    lineHeight: '14px',
  },
  periodFilterBtn: {
    padding: 0,
    transition: 'all .4s',
    color: colors.primary,
    '&:hover': {
      opacity: '.7',
      backgroundColor: '#FFF',
    },
  },
})

export default function Filter({}) {
  const meta = useSelector(state => state.partnerAttendances.meta)
  const role = useSelector(state => state.auth.role)

  const location = useLocation()
  const history = useHistory()
  const filters = useQueryParams(location.search)

  const dispatch = useDispatch()
  const confirm = useConfirm()

  const filterClasses = filterStylesComponents()
  const styles = useStyles()

  const [pickerOpen, setPickerOpen] = useState(false)

  const filteredDate = useMemo(() => {
    if (!filters?.date) return new Date()
    return new Date(filters?.date)
  }, [filters])

  const handlePickDate = date => {
    if (!date) return
    onSubmit({ ...filters, date: date?.toISOString() })
  }

  const handleChangeDate = (prev = false) => {
    const steps = {
      true: new Date(filteredDate?.setMonth(filteredDate?.getMonth() - 1)),
      false: new Date(filteredDate?.setMonth(filteredDate?.getMonth() + 2)),
    }
    const date = steps[prev] || new Date()
    onSubmit({ ...filters, date: date?.toISOString() })
  }

  const handleCloseAllOs = () => {
    confirm({
      description: 'Deseja realmente fechar todas as OSs?',
      title: 'Tem certeza?',
      confirmationText: 'Sim',
      cancellationText: 'Cancelar',
      dialogProps: {
        fullWidth: true,
      },
    }).then(() => {
      dispatch(closeAllLaundryOSs())
      dispatch(
        fetchAttendancePartner(filters, meta?.per_page, meta?.current_page)
      )
    })
  }

  const onSubmit = (data = filters) => {
    const searchParams = new URLSearchParams(data)
    searchParams.set('page', 1)
    history.push(`${location?.pathname}?${searchParams?.toString()}`)
  }

  const handleSubmit = e => {
    e.preventDefault()

    const formData = e.currentTarget
    const data = new FormData(formData)
    data.append('date', filteredDate.toISOString())
    const entries = data.entries()
    const values = Object.fromEntries(entries)

    onSubmit({ ...filters, ...values })
  }

  return (
    <BaseFilter>
      <Grid item xs={12}>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          spacing={2}
        >
          <Grid item xs={10} sm={6} md={5} lg={3}>
            <form style={{ width: '100%' }} onSubmit={handleSubmit}>
              <Input
                fullWidth
                name="partner"
                defaultValue={filters?.partner}
                id="standard-adornment-person"
                placeholder="Pesquise por Parceiro"
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton aria-label="search name" type="submit">
                      <Icon path={mdiMagnifyExpand} size={1} />
                    </IconButton>
                  </InputAdornment>
                }
              />
            </form>
          </Grid>

          <Grid item xs={12} sm={12} md>
            <Grid container alignItems="center" justifyContent="flex-end">
              <Grid item sm={4} xs={12} className={filterClasses.areaButtons}>
                <Box className={styles.periodFilter}>
                  <IconButton
                    onClick={() => handleChangeDate(true)}
                    className={styles.periodFilterBtn}
                  >
                    <Icon path={mdiMenuLeft} size={0.7} />
                  </IconButton>

                  <Box
                    onClick={() => setPickerOpen(true)}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                      cursor: 'pointer',
                    }}
                  >
                    <EventIcon fontSize="small" />
                    <Typography>
                      {format(filteredDate, "MMMM 'de' yyyy", {
                        locale: ptBR,
                      })}
                    </Typography>
                  </Box>

                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                    <DatePicker
                      views={['year', 'month']}
                      openTo="month"
                      value={filteredDate}
                      onChange={handlePickDate}
                      open={pickerOpen}
                      onOpen={() => setPickerOpen(true)}
                      onClose={() => setPickerOpen(false)}
                      format="MMMM yyyy"
                      autoOk
                      TextFieldComponent={() => null}
                    />
                  </MuiPickersUtilsProvider>

                  <IconButton
                    onClick={() => handleChangeDate()}
                    className={styles.periodFilterBtn}
                  >
                    <Icon path={mdiMenuRight} size={0.7} />
                  </IconButton>
                </Box>

                {renderRouteRole(['gerente_lavanderia'], role) && (
                  <IconButton
                    className={filterClasses.btnAdd}
                    onClick={() => {
                      dispatch(
                        exportOSsRelatory(filters, 'laundryService/os-report')
                      )
                    }}
                  >
                    <Icon path={mdiMicrosoftExcel} size={1} />
                    Download
                  </IconButton>
                )}

                {renderRouteRole(['gerente_lavanderia'], role) && (
                  <IconButton
                    className={filterClasses.btnAdd}
                    onClick={handleCloseAllOs}
                    style={{ backgroundColor: colors.error }}
                  >
                    Fechar Todas
                  </IconButton>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </BaseFilter>
  )
}
